import { fetch } from "../plugin/fetch";
export default {
    namespaced: true,
    state: {
        menu: [], 
        nav: {},
        qrcode: ''
    },
    mutations: {
        fetchGloble(state, payload) {
            state.menu = payload.menu || [];
            state.nav = payload.nav || {};
            state.qrcode = payload.qrcode || '';
        }
    },
    actions: {
        // fetchGloble({ commit }) {
        //     return new Promise(() => {
        //         fetch('').then(res => {
        //             if (res.code==200) {
        //                 commit('fetchGloble', res.data);
        //             }
        //         });
        //     });
        // }
    }
}